import getAdDetail from '@/api/get-ad-detail';
import store from './index';
function getDefaultOptions() {
  return {
    adId: '',
    status: '',
    adType: '',
    crypto: '',
    payment: [],
    fiatCurrency: '',
    location: '',
    isFixed: false,
    fixedPrice: '',
    reference: '',
    isAbove: '',
    percentage: '',
    difference: '',
    lowestPrice: '',
    tradeAmountMin: '',
    tradeAmountMax: '',
    timeZone: '',
    timeStart: '',
    timeEnd: '',
    title: '',
    provisions: '',
    traders: [],
    attribute: 0,
    isCheck: false,
  };
}
export const adTempState = {
  adTemp: getDefaultOptions(),
  adStore: getDefaultOptions(),
};
export const adTempMutations = {
  setCreateTemp(state, obj) {
    if (obj.isNew !== undefined) {
      if (obj.isNew) {
        state.adTemp = getDefaultOptions();
        return;
      }
    }
    Object.assign(state.adTemp, obj);
  },
  setAdStore(state, obj) {
    if (obj.isNew !== undefined) {
      if (obj.isNew) {
        state.adStore = getDefaultOptions();
        return;
      }
    }
    Object.assign(state.adStore, obj);
  },
};

export const adTempActions = {
  updateAdStore({ commit }, { id }) {
    return getAdDetail(id).then(data => {
      const d = data.data;
      const reference = store.state.settings.referenceList.findIndex(
        item => item.value == d.curr_type,
      );
      const obj = {
        adId: d.id,
        status: d.status,
        adType: d.type,
        crypto: d.asset.id,
        payment: d.payMethods.map(item => item.id),
        fiatCurrency: d.legalCurrency.id,
        location: d.location.id,
        isFixed: !d.isCurr,
        fixedPrice: !d.isCurr ? d.price : '',
        reference: !d.isCurr ? '' : reference || 0,
        difference: d.price_gap,
        isAbove: !d.isCurr ? '' : d.isAbove,
        percentage: d.isCurr ? d.percentage : '',
        tradeAmountMin: Number(d.minPrice),
        tradeAmountMax: Number(d.maxPrice),
        timeZone: +d.zone + 12,
        timeStart: d.ontimeStart,
        timeEnd: d.ontimeEnd,
        title: d.title || '',
        provisions: d.description || '',
        traders: d.propertys.map(item => item.id) || [],
        attribute: d.attribute,
        lowestPrice: d.lowestPrice,
        isCheck: !!+d.isCheck,
      };
      commit('setAdStore', obj);
    });
  },
};
